/* global preact, Hypher */
import { getDom } from './parser';
import { findMap, getProp } from './parser/tools';
import { query, textContents } from './nav-tools';
import { s } from './parser/spchars';

function findLang(prefs) {
  const langs = Object.keys(prefs)
    .filter(x => /^lang=/.test(x))
    .map(x => {
      const [, key, pat] = x.split('=');
      const rx = new RegExp(pat, 'i');
      return { key, rx, val: prefs[x] };
    });
  const stackLang = findMap(prefs.stack, obj => {
    let rxLang;
    if (obj.tag === 'style') return '-';
    else if (obj.attrs?.lang) return obj.attrs.lang;
    /* eslint-disable-next-line no-cond-assign */
    else if (rxLang = langs.find(x => x.rx.test(obj[x.key]))) return rxLang.val;
  });
  if (stackLang) return stackLang;
  return prefs.lang;
}

function arrLazy(obj, root, prefs) {
  let lzh = tag => x => prefs.hyper(prefs.hlazy, {
    tag,
    render: tdh.bind(null, prefs),
    elements: x,
  });
  if (root && prefs.lazy && prefs.hlazy) {
    // console.log('lazy', obj.length);
    const lz = prefs.lazy;
    if (typeof lz === 'number') { // grab batches of size lz and lazy them
      const lazies = [];
      /* eslint-disable-next-line no-unmodified-loop-condition */
      while (root && obj.length > lz) {
        lazies.push(obj.splice(lz, lz));
      }
      obj = obj.concat(lazies);
      lzh = lzh('h1');
    } else if (typeof lz === 'function' && obj.length > 50) {
      // find headers via fn and lazy following tags
      const hs = obj.map((x, i) => lz(x) ? i : null).filter(x => x !== null);
      if (hs.length) {
        const no = obj.slice(0, hs[0]);
        hs.forEach((x, i, a) => {
          const last = a.length > i + 1 ? a[i + 1] : obj.length;
          no.push(obj[x]);
          if (x + 1 < last) no.push(obj.slice(x + 1, last));
        });
        obj = no;
        lzh = lzh();
      }
    }
  }
  return [obj, lzh];
}

function normPrefs(prefs) {
  return {
    stack: [],
    render: preact.render,
    hyper: preact.h,
    elGabc: preact.c.gabc,
    elFrag: preact.Fragment,
    hlazy: preact.c.lazy,
    arrLazy: arrLazy,
    ...prefs,
  };
}

function tdh(prefs2, obj, root) {
  let prefs = prefs2;
  if (root && root !== 999) { prefs = normPrefs(prefs2); }

  if (typeof obj === 'string') {
    if (prefs.hyph && typeof Hypher !== 'undefined') {
      const lang = findLang(prefs);
      // const { lang } = prefs.stack.find(x => (x.attrs || {}).lang) || prefs;
      const hyph = Hypher.languages[lang];
      if (hyph) obj = hyph.hyphenateText(obj);
      // else console.log('hyph language not found', lang);
    }
    return obj;
  } else if (Array.isArray(obj)) {
    const [arr, lzh] = prefs.arrLazy(obj, root, prefs);

    return prefs.hyper(prefs.elFrag, null,
      arr.map(x => Array.isArray(x) ? lzh(x) : tdh(prefs, x)));
  } else if (obj?.tag === 'prefs') {
    // default/global prefs
    Object.assign(prefs, obj.attrs);
  } else if (prefs?.print && obj?.attrs?.screen) {
    return null;
  } else if (prefs.elGabc && obj?.tag === 'bc'
    && obj?.attrs?.lang === 'gabc') {
    // console.log(obj);
    return prefs.hyper(prefs.elGabc, {
      gabc: obj.children.join('\n'),
      cap: obj.attrs.cap,
    });
  } else if (obj?.tag) {
    prefs.stack.unshift(obj);
    let attrs = obj.attrs;
    if (obj.attrs?.tagfn) {
      console.log('tag fn', obj);
      attrs = { tag: obj.tag, ...obj.attrs };
      delete attrs.tagfn;
    }
    const retval = prefs.hyper(obj.attrs?.tagfn || obj.tag, attrs,
      obj.children.map(x => tdh(prefs, x)));
    prefs.stack.shift();
    return retval;
  } else {
    // console.trace('tdh failed', prefs2, obj, root);
    return '';
  }
}

function render(obj, target, prefs2) {
  const prefs = normPrefs(prefs2);
  prefs.renderOutput = prefs.render(tdh(prefs, obj, 999), target);
  return prefs;
}

function replace(txt, o, n) {
  return txt.replace(new RegExp(o, 'g'), n);
}
function getSpecials(txt) {
  return txt.match(/[^\x20-\x7f\r\n]/g);
}
function hilite(el, txt, cb) {
  txt = stdReplace(txt, cb);
  /* eslint-disable-next-line no-control-regex */
  let m = getSpecials(txt);
  const { h } = preact;
  if (m) {
    m = m.filter((x, i) => i === m.indexOf(x)); // distinct
    preact.render(h('div', null,
      m.map(x => h(charmatch, { key: x.charCodeAt(0), char: x, cb, txt })),
    ), el);
  } else { el.innerHTML = ''; }
}

function charmatch({ key, char, cb, txt }) {
  const { h } = preact;
  const [repl, setRepl] = preact.useState('');
  const hex = char.charCodeAt(0).toString(16);
  return h('div', null,
    [char, h('input', {
      value: repl,
      onChange: e => setRepl(e.target.value),
    }), hex],
    h('button', {
      onClick: e => cb(replace(txt, char, repl)),
    }, 'Repl'), ' ',
    h('button', {
      onClick: e => cb(replace(txt, char, `&#${hex};`)),
    }, 'Escape'),
  );
}

function stdReplace(txt, cb) {
  let newTxt = txt;
  const x = '\u2013'.split('');
  const y = '--'.split(',');
  for (let i = 0; i < x.length; i++) {
    newTxt = replace(newTxt, x[i], y[i]);
  }
  Object.entries(s).forEach(([pat, code]) => {
    // const otxt = newTxt;
    if (/([lr]['"]|[<>-])/.test(pat)) {
      newTxt = replace(newTxt, code, pat.replace(/[lr]/g, ''));
    } else {
      newTxt = replace(newTxt, code, '\\' + pat);
    }
    // if (otxt !== newTxt) console.log({ pat, code, otxt, newTxt });
  });
  if (txt !== newTxt) cb?.(newTxt);
  return newTxt;
}

function getPrefs(intxt) {
  if (typeof intxt !== 'string') return null;
  const m = intxt.match(/^prefs[\S]+\./)?.[0] + ' ';
  if (!m) return null;
  const s2 = getDom(m);
  return s2?.dom?.[0]?.attrs;
}

export const texdown = {
  getDom,
  getPrefs,
  render,
  tdh,
  hilite,
  query,
  textContents,
  getProp,
  stdReplace,
  getSpecials,
};
